import type {
  CreateCrewInput,
  CrewDetail,
  CrewFormOptions,
  CrewSummary,
  UpdateCrewInput,
} from "@crewledger/shared/schemas";
import { apiFetch } from "@/lib/api";

export async function fetchCrews(params?: {
  page?: number;
  pageSize?: number;
  siteId?: string;
  active?: boolean;
  q?: string;
}) {
  const search = new URLSearchParams();
  if (params?.page) search.set("page", String(params.page));
  if (params?.pageSize) search.set("pageSize", String(params.pageSize));
  if (params?.siteId) search.set("siteId", params.siteId);
  if (params?.active !== undefined) search.set("active", String(params.active));
  if (params?.q) search.set("q", params.q);
  const qs = search.toString();
  return apiFetch<{ data: CrewSummary[]; meta: { total?: number } }>(`/api/crews${qs ? `?${qs}` : ""}`);
}

export async function fetchCrewOptions() {
  return apiFetch<{ data: CrewFormOptions }>("/api/crews/options");
}

export async function fetchCrew(crewId: string) {
  return apiFetch<{ data: CrewDetail }>(`/api/crews/${crewId}`);
}

export async function createCrew(input: CreateCrewInput) {
  return apiFetch<{ data: CrewDetail }>("/api/crews", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function updateCrew(crewId: string, input: UpdateCrewInput) {
  return apiFetch<{ data: CrewDetail }>(`/api/crews/${crewId}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}
